import { Injector } from "@angular/core";
import { MeddraService } from "../../../../service/meddra-service/meddra.service";
import { MeddraNode } from "../MeddraNode";
import { TreeNodeMeddraLevelItem } from "./TreeNodeMeddraLevelItem";
import { environment } from "../../../../../../environments/environment";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { LLTListView } from "../../../Data/MeddraData/LLTListVIew";
import { HLTListView } from "../../../Data/MeddraData/HLTListView";
import { FieldDefinition } from "../../../../../sections/meddra/message/fieldDefinition";
import { MeddraTerm } from "../../../Data/MeddraData/MeddraTerm";
import { DummyNode } from "../../DummyNode";
import { HierarchyMode } from '../../../MeddraEnum';
import { EntityEnum } from "../../EntityEnum";
import { BaseNode } from "../../BaseNode";
import { SOCListView } from "../../../Data/MeddraData/SOCListView";


export class TreeNodePTItem extends TreeNodeMeddraLevelItem {

    constructor(injector: Injector, data: any, parent: BaseNode) {
        super(injector, data, EntityEnum.pt, injector.get(Art57Section).meddra.ptTermsTreeNode, parent);
        this.children?.push(new DummyNode());
    }

    override createChildren(): void {

        //Retrieve "Low Level term for this Preferred term"
        let lltNode = new MeddraNode(this.ioc!, new LLTListView([]), `Low Level Terms ({param})`, EntityEnum.llt, null, this, HierarchyMode.DESCENDING);
        this.children!.push(lltNode);
        this.ioc?.get(MeddraService).getAll(this,EntityEnum.llt, `pt_code:eq:${this.data.model.code}`).subscribe(
            {
                next: (data:any) => {
                    lltNode.data = new LLTListView(data.result);
                    data.result.forEach((i: any) => lltNode.children!.push(new MeddraNode(this.ioc!, new MeddraTerm(new FieldDefinition(this.ioc!).lltFields, i), i.name, EntityEnum.llt,this.ioc!.get(Art57Section).meddra.lltTermsTreeNode, lltNode, HierarchyMode.DESCENDING)));
                    lltNode.refreshLabel();
                }, error: () => {
                    this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'error', detail: 'Error found', life: environment.errorElapsedTime });
                }
            });

        //Retrieve "High Level Terms for this Preferred term"
        let hltNode = new MeddraNode(this.ioc!, new HLTListView([]), `High Level Terms ({param})`, EntityEnum.hlt, null, this, HierarchyMode.ASCENDING);
        this.children!.push(hltNode);
        this.ioc?.get(MeddraService).getAll(this,EntityEnum.hlt, `pt_code:eq:${this.data.model.code}`).subscribe(
            {
                next: (data:any) => {
                    hltNode.data = new HLTListView(data.result);
                    data.result.forEach((i: any) => hltNode.children!.push(new MeddraNode(this.ioc!, new MeddraTerm(new FieldDefinition(this.ioc!).hltFields, i), i.name, EntityEnum.hlt,this.ioc!.get(Art57Section).meddra.hltTermsTreeNode, hltNode, HierarchyMode.ASCENDING)));
                    hltNode.refreshLabel();
                }, error: () => {
                    this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'error', detail: 'Error found', life: environment.errorElapsedTime });
                }
            });

        //Retrieve "primary soc"
        let primarySocNode = new MeddraNode(this.ioc!, new SOCListView([]), `Primary System Organ class (es)`, EntityEnum.soc, null, this, HierarchyMode.ASCENDING);
        this.children!.push(primarySocNode);
        this.ioc?.get(MeddraService).getAll(this,EntityEnum.soc, `code:eq:${this.data.model.primarySOC}`).subscribe(
            {
                next: (data:any) => {
                    data.result.forEach((i: any) => primarySocNode.children!.push(new MeddraNode(this.ioc!, new MeddraTerm(new FieldDefinition(this.ioc!).socFields, i), i.name, EntityEnum.soc, this.ioc!.get(Art57Section).meddra.socTermsTreeNode, primarySocNode, HierarchyMode.ASCENDING)));
                    primarySocNode.refreshLabel();
                }, error: () => {
                    this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'error', detail: 'Error found', life: environment.errorElapsedTime });
                }
            });

        //Retrieve all linked system organ class
        let allSOCnode = new MeddraNode(this.ioc!, new SOCListView([]), `All linked System Organ class (es)`, EntityEnum.soc, null, this, HierarchyMode.ASCENDING);
        this.children!.push(allSOCnode);
        this.ioc?.get(MeddraService).getAll(this,EntityEnum.soc, `pt_code:eq:${this.data.model.code}`).subscribe(
            {
                next: (data:any) => {
                    data.result.forEach((i: any) => allSOCnode.children!.push(new MeddraNode(this.ioc!, new MeddraTerm(new FieldDefinition(this.ioc!).socFields, i), i.name, EntityEnum.soc,this.ioc!.get(Art57Section).meddra.socTermsTreeNode, allSOCnode, HierarchyMode.ASCENDING)));
                }, error: () => {
                    this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'error', detail: 'Error found', life: environment.errorElapsedTime });
                }
            });



    }
}